import ReactPortal from "../Utils/ReactPortal";

const StoreListContainer = (props) => {
    const markerListContainer = document.querySelector('#marker-list')
    if (props.isOpenSwiperMenu){
        markerListContainer.classList.add('marker-list-animation-parent')
    } else {
        markerListContainer.classList.remove('marker-list-animation-parent')
    }
    return (
        <ReactPortal id={`marker-list`}>
            <div className={`marker-list-container ${props.isOpenSwiperMenu ? 'marker-list-animation' : ''} ${props.isLoading ? 'is-loading' : ''}` }>
                <div className={'marker-list-menu-title'}><div>Dans cette zone </div><div className={'marker-list-menu-circle'}>{props.visibleMarkersListLength ? props.visibleMarkersListLength : '0'}</div></div>
                {props.children}
            </div>
        </ReactPortal>
    )
}

export default StoreListContainer